import { AccountingReferencesDetailsResponse } from './types';

/**
 * Select function to map the accounting references details response data to the data needed for the usage details table.
 * @param data - The accounting references details response data.
 * @returns The mapped accounting references details data.
 */
export function mapAccountingReferencesDetailsRow(
  data: AccountingReferencesDetailsResponse,
) {
  return {
    hasNextPage: data.hasNextPage,
    rows: data.data,
    totalCount: data.totalCount,
  };
}
